import UnavailableProductRefillCard from '@/components/products/refill/UnavailableProductRefillCard';
import { IssueStatuses } from '@/hooks/escript/types';
import { sortProductIssues } from '../../../pages/escript/order-medication/util';
import type { CantOrderDevicesProps } from './types';
import { isDevice } from './utils';

export function CantOrderDevices({ devices }: CantOrderDevicesProps) {
  return (
    <>
      {devices.sort(sortProductIssues).map((pip) => {
        if (!pip.issue || !isDevice(pip.product)) {
          return null;
        }

        const device = pip.product;

        return (
          <UnavailableProductRefillCard
            key={device.id}
            product={{
              id: device.id,
              name: device.name,
              price: device.price,
              brand: device.brand,
              is_out_of_stock: device.productIssueStatus === IssueStatuses.OUT_OF_STOCK,
              is_generative_scripting: false,
              reasoning_toggle: pip.issue.info && pip.issue.info.length > 0,
            }}
            issue={pip.issue}
            handleCheckProductStatus={null}
          />
        );
      })}
    </>
  );
}
